export enum TipoRevision {
  INDIVIDUAL = 'INDIVIDUAL',
  PARES = 'PARES',
  PLENARIA = 'PLENARIA',
  CONSEJO = 'CONSEJO',
}
